__turbopack_context__.v({
  "buttonsWrapper": "q_Nn1q_buttonsWrapper",
  "form": "q_Nn1q_form",
});
